import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getDefaultPathForUser, useAuth } from "../context/AuthContext";
import { hasPermission } from "../permissions";

export default function ProtectedRoute({ children, requiredPermission }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner" />
        <span>Загрузка...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to={getDefaultPathForUser(user)} replace />;
  }

  return children;
}
